import { useEffect, useRef } from 'react';

const showRenders = false
const showMounts = false
const showAlwaysMounts = false

export const useRenders = (name, showTime = false, alwaysShow = false, other = null) => {

  const renders = useRef(0);
  const start = performance.now();

  renders.current++;
  const over5 = renders.current > 5

  if (showRenders) {
    if (showTime) {
      if (over5) {
        console.log(
          `🔄🔄 ${name} render #${renders.current}`,
          `${(performance.now() - start).toFixed(2)}ms`
        );
      } else {
        console.log(
          `🔄 ${name} render #${renders.current}`,
          `${(performance.now() - start).toFixed(2)}ms`
        );
      }
    } else {
      if (over5) {
        console.log(`🔄🔄 ${name} render #${renders.current}`);
      } else {
        console.log(`🔄 ${name} render #${renders.current}`);
      }
    }
  }


  useEffect(() => {
    if ((!showMounts && !alwaysShow) || !showAlwaysMounts) return;
    console.log(`🟢🟢 ${name} MOUNT`, other);
    return () => {
      console.log(`🔴🔴🔴 ${name} UNMOUNT`);
    };
  }, [name]);

  return renders.current;
};